import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
class ResourcesMenuOption extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            userData: this.props.userData,
			isOpen: this.props.isOpen,
            currentFocus: this.props.currentFocus
        };
        this.setClass = this.setClass.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
		if(this.state.isOpen !== nextProps.isOpen){
			this.setState({isOpen:  nextProps.isOpen});
		}
		if(this.state.currentFocus !== nextProps.currentFocus){
			this.setState({currentFocus: Object.assign({}, nextProps.currentFocus)});
		}
    }

    componentDidUpdate() {

    }

    onSelect() {
        this.props.onSelectFunc(this.props.params);
    }

    setClass() {
        let className = "";
        let userDataObject = userDataHelper.getResourceScreenUserData(this.state.userData, this.props.params.screen_id);
        if(appHelper.isDefined(userDataObject)) {
            if (userDataObject.status === objectConstants.STATUS_NOT_STARTED) {
                className += `${objectConstants.CLASS_NOT_STARTED} `;
            } else if (userDataObject.status === objectConstants.STATUS_IN_PROGRESS) {
                className += `${objectConstants.CLASS_IN_PROGRESS} `;
            } else if (userDataObject.status === objectConstants.STATUS_COMPLETE) {
                className += `${objectConstants.CLASS_COMPLETE} `;
            }
        }

        return className;
    }

    onClicked() {
        this.props.onClickFunc(this.state.screen);
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.onSelect();
        }
    }

    render() {
        return (
            <div className={`option-label ${this.setClass()} ${this.props.activeClass}`}
               onClick={this.onSelect} dangerouslySetInnerHTML={{__html:this.props.label}} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={this.state.isOpen && this.props.params.screen_id === this.state.currentFocus.screen_id ? "0" : "-1"}/>
        );

    }
}

ResourcesMenuOption.propTypes = {
    onSelectFunc: PropTypes.func,
    params: PropTypes.object.isRequired,
    label: PropTypes.string,
    activeClass: PropTypes.string,
    activeScreenId: PropTypes.number,
    onClickFunc: PropTypes.func,
	isOpen: PropTypes.bool,
	currentFocus: PropTypes.object,
    userData: PropTypes.object,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    actions: PropTypes.object
};

ResourcesMenuOption.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        contentData: state.contentData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ResourcesMenuOption);


/** WEBPACK FOOTER **
 ** ./src/components/dialogs/resources/ResourcesMenuOption.js
 **/